var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Newsletter = (function (Newsletter) {

        Newsletter.Messages = (function (Messages) {

            Messages.Subscribe = function (email, subscriptionType, apiKey, mailparams, mailLists, gender) {

                var data = {
                    email: email,
                    subscriptionType: subscriptionType,
                    apiKey: apiKey,
                    mailparams: mailparams || {},
                    mailLists: mailLists,
                    gender: gender
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.Subscribe", data);
            };
            Messages.Subscribe.className = "Vendd.Newsletter.Messages.Subscribe";

            Messages.SubscribeSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeSuccess", response);
            };
            Messages.SubscribeSuccess.className = "Vendd.Newsletter.Messages.SubscribeSuccess";

            Messages.SubscribeFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeFailure", response);
            };
            Messages.SubscribeFailure.className = "Vendd.Newsletter.Messages.SubscribeFailure";

            Messages.UpdateNewLetterVariables = function (source, apikey) {

                var data = { source: source, apikey: apikey };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UpdateNewLetterVariables", data);
            }
            Messages.UpdateNewLetterVariables.className = "Vendd.Newsletter.Messages.UpdateNewLetterVariables";


            Messages.Unsubscribe = function (apiKey) {

                var data = {
                    apiKey: apiKey
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.Unsubscribe", data);
            };
            Messages.Unsubscribe.className = "Vendd.Newsletter.Messages.Unsubscribe";

            Messages.UnsubscribeSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UnsubscribeSuccess", response);
            };
            Messages.UnsubscribeSuccess.className = "Vendd.Newsletter.Messages.UnsubscribeSuccess";

            Messages.UnsubscribeFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UnsubscribeFailure", response);
            };
            Messages.UnsubscribeFailure.className = "Vendd.Newsletter.Messages.UnsubscribeFailure";

            return Messages;

        })(Newsletter.Messages || {});

        Vendd.MessageBus.subscribe(Newsletter.Messages.Subscribe, Newsletter, function (envelope) {

            var $email = envelope.message.data.email;

            var serviceOpts = {
                url: 'NewsLetterService.svc/Subscribe',
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.SubscribeSuccess($.extend({},response, { 'email' : $email })));
            };

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.SubscribeFailure(response));
            };

            Vendd.Service.call(serviceOpts);
        });

        Vendd.MessageBus.subscribe(Newsletter.Messages.UpdateNewLetterVariables, Newsletter, function (envelope) {
            function onSuccess(response) {

            }
            function onFailure(response) {

            }
            var options = {
                url: 'NewsLetterService.svc/UpdateNewsLetterVariables',
                data: {
                    source: envelope.message.data.source,
                    apiKey: envelope.message.data.apikey
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            var clientModel = Vendd.User && Vendd.User.GetClientModel();
            if (clientModel && clientModel.IsAuthenticated)
                Vendd.Service.call(options);
        });

        Vendd.MessageBus.subscribe(Newsletter.Messages.Unsubscribe, Newsletter, function (envelope) {

            var serviceOpts = {
                url: 'NewsLetterService.svc/Unsubscribe',
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UnsubscribeSuccess(response));
            };

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UnsubscribeFailure(response));
            };

            Vendd.Service.call(serviceOpts);
        });

        return Newsletter;

    })(Vendd.Newsletter || {});

    return Vendd;

})(Vendd || {});